import { render } from "./DocumentProcessList.vue?vue&type=template&id=4d1f8f18&scoped=true&ts=true"
import script from "./DocumentProcessList.vue?vue&type=script&lang=ts"
export * from "./DocumentProcessList.vue?vue&type=script&lang=ts"

import "./DocumentProcessList.vue?vue&type=style&index=0&id=4d1f8f18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1f8f18"]])

export default __exports__